export default __webpack_public_path__ + "images/fa00bb38fe0bc3b3c52ec4a4030bc49f.svg";